﻿import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import layoutReducer from './slices/layout';
import metricsReducer from './slices/metrics';
import analysesReducer from './slices/analyses';
import reportsReducer from './slices/reports';
import administrationReducer from './slices/administration';
import { globalConfig } from '../settings/global.config';

const isDevMode = globalConfig.configuration.environment.name === 'development';

const reducers = {
	layout: layoutReducer,
	metrics: metricsReducer,
	analyses: analysesReducer,
	reports: reportsReducer,
	administration: administrationReducer
};

const createReducers = (shouldPersist = true) => {
	if (!shouldPersist) {
		return reducers;
	}

	const persistedReducers = {};

	Object.entries(reducers).forEach(([name, reducer]) => {
		const persistConfig = {
			key: name,
			storage
		};
		persistedReducers[name] = persistReducer(persistConfig, reducer);
	});

	return persistedReducers;
};

export const createAppStore = (options = {}) => {
	const { initialState = window.initialReduxState || {}, shouldPersist = true, devTools = isDevMode } = options;

	const storeReducers = createReducers(shouldPersist);

	const store = configureStore({
		reducer: storeReducers,
		preloadedState: initialState,
		devTools,
		middleware: getDefaultMiddleware =>
			getDefaultMiddleware({
				immutableCheck: false,
				serializableCheck: false
			})
	});

	return {
		store,
		persistor: shouldPersist ? persistStore(store) : null
	};
};

const store = createAppStore();

export default store;
